import { render, staticRenderFns } from "./shop-info-form.vue?vue&type=template&id=c60996be&scoped=true&"
import script from "./shop-info-form.vue?vue&type=script&lang=js&"
export * from "./shop-info-form.vue?vue&type=script&lang=js&"
import style0 from "./shop-info-form.vue?vue&type=style&index=0&id=c60996be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60996be",
  null
  
)

export default component.exports